const AnswerTypes = {
    YES: 'YES',
    NO: 'NO'
};

export default AnswerTypes;